export const NOTIFICATION = {
  GET_NOTIFICATIONS: "notification/GET_NOTIFICATIONS",
  READ_NOTIFICATION: "notification/READ_NOTIFICATION",
  PUSH_NOTIFICATION: "notification/PUSH_NOTIFICATION",
};
